const React = require('react');
const { default: InputAdornment } = require('@mui/material/InputAdornment');

const { MESSAGES_SORT_TYPE } = require('utils/constants');

const internals = {};

internals.buildSortOptions = () => ([
    {
        value: MESSAGES_SORT_TYPE.BY_DATE_UPDATED,
        label: 'Recent'
    },
    {
        value: MESSAGES_SORT_TYPE.BY_NAME,
        label: 'A-Z'
    }
]);

internals.buildRoleOptions = (availableRoleGroups = []) => ([
    { value: '', label: 'Any' },
    ...availableRoleGroups.map((roleGroup) => ({
        label: roleGroup?.label || roleGroup?.name || '',
        value: roleGroup?.filter || roleGroup?.value || ''
    })).filter((option) => option.label && option.value)
]);

internals.resolveRoleGroupFilterValue = ({
    availableRoleGroups = [],
    roleGroupFilter
}) => {

    if (!roleGroupFilter) {
        return '';
    }

    const matchingOption = internals.buildRoleOptions(availableRoleGroups)
        .find((option) => option.value === roleGroupFilter);

    return matchingOption?.value || '';
};

internals.buildFields = ({
    SearchIconComponent,
    availableRoleGroups = [],
    onRoleGroupFilterChange,
    onSearchChange,
    onSortChange,
    searchFieldStyles,
    selectFieldStyles
} = {}) => {

    const controlItems = [{
        type: 'SelectField',
        name: 'sortType',
        label: 'Show By',
        options: internals.buildSortOptions(),
        onChange: onSortChange,
        textFieldProps: {
            variant: 'filled',
            fieldStyles: selectFieldStyles,
            InputLabelProps: {
                shrink: true
            },
            InputProps: {
                disableUnderline: true
            },
            inputProps: {
                'aria-label': 'Show By'
            }
        }
    }];

    const roleOptions = internals.buildRoleOptions(availableRoleGroups);

    if (roleOptions.length > 1) {
        controlItems.push({
            type: 'SelectField',
            name: 'roleGroupFilter',
            label: 'Role',
            options: roleOptions,
            onChange: onRoleGroupFilterChange,
            textFieldProps: {
                disabled: roleOptions.length === 1,
                variant: 'filled',
                fieldStyles: selectFieldStyles,
                InputLabelProps: {
                    shrink: true
                },
                InputProps: {
                    disableUnderline: true
                },
                inputProps: {
                    'aria-label': 'Role'
                }
            }
        });
    }

    return [{
        type: 'group',
        fields: controlItems
    }, {
        type: 'TextField',
        name: 'search',
        label: '',
        placeholder: 'Search names',
        fullWidth: true,
        onChange: onSearchChange,
        textFieldProps: {
            id: 'connections-search',
            fieldStyles: searchFieldStyles,
            InputProps: {
                disableUnderline: true,
                startAdornment: SearchIconComponent
                    ? <InputAdornment position='start'>
                        <SearchIconComponent />
                    </InputAdornment>
                    : undefined
            },
            inputProps: {
                'aria-label': 'Search names'
            }
        }
    }];
};

module.exports.buildDefaults = function buildDefaults({
    allMessagesSortType,
    availableRoleGroups = [],
    dmsFilter,
    roleGroupFilter
} = {}) {

    return {
        roleGroupFilter: internals.resolveRoleGroupFilterValue({
            availableRoleGroups,
            roleGroupFilter
        }),
        search: dmsFilter || '',
        sortType: allMessagesSortType || MESSAGES_SORT_TYPE.BY_DATE_UPDATED
    };
};

module.exports.buildFormConfig = function buildFormConfig(props) {

    const {
        allMessagesSortType,
        availableRoleGroups,
        dmsFilter,
        roleGroupFilter,
        SearchIconComponent,
        onRoleGroupFilterChange,
        onSearchChange,
        onSortChange,
        onSubmit
    } = props;

    return {
        formId: 'direct-messages-filter-form',
        fields: internals.buildFields({
            SearchIconComponent,
            availableRoleGroups,
            onRoleGroupFilterChange,
            onSearchChange,
            onSortChange,
            searchFieldStyles: props.searchFieldStyles,
            selectFieldStyles: props.selectFieldStyles
        }),
        defaults: module.exports.buildDefaults({
            allMessagesSortType,
            availableRoleGroups,
            dmsFilter,
            roleGroupFilter
        }),
        onSubmit
    };
};
module.exports.internals = internals;
